import {calculateChoicePoints} from '../utils.js';

export default function extractChoices (componentElement, props, data, obj) {
    let result = {};
    if(props.type=='select'){
        if(obj.mode == 2) {
            const element = componentElement.querySelector('.x-answer-select');
            result.answer = Array.from(element.options).filter(option => {
                return option.selected && option.value;
            }).map(x => x.value);
            return result;
        }
    }        
    const elements = componentElement.querySelectorAll('.x-choice-answer');
    if(elements) {
        result.choices = Array.from(elements).map(choice => {
            return choice.value;
        });             
        const answer = Array.from(elements).filter(choice => {
            return choice.checked;
        }).map(x => x.value);
        if(obj.mode == 1){
            result.correct_answer = answer;
        } else {
            result.answer = answer;
        }
    }
    if(obj.mode == 1){
        const points = calculateChoicePoints(componentElement);
        if(points.total_choice_points) {
            result = {...result, ...points};
            result.max_point = props.type == 'checkbox' ? result.total_choice_points : result.max_choice_points;
        }
    }
    return result;
}